import { render, staticRenderFns } from "./TemplateSelector.vue?vue&type=template&id=ddec3b80&scoped=true"
import script from "./TemplateSelector.vue?vue&type=script&lang=js"
export * from "./TemplateSelector.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelector.vue?vue&type=style&index=0&id=ddec3b80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddec3b80",
  null
  
)

export default component.exports